import React from 'react';

import {
  useNavigate,
} from 'react-router-dom';

import {
  FontAwesomeIcon,
} from '@fortawesome/react-fontawesome';

import {
  faBookOpen,
  faPlay,
  faStar,
  faBullseye,
  faTrophy,
  faArrowLeft,
} from '@fortawesome/free-solid-svg-icons';

import './ContaPrimaraSyllabus.css';


const ContaPrimaraSyllabus = ({
  unit,
  onBack,
}) => {

  const navigate =
    useNavigate();


  /* =====================================================
     PROTECTIE UNITATE
  ===================================================== */

  if (!unit) {
    return (
      <div className="conta-syllabus-page">

        <div className="conta-syllabus-shell">

          <button
            type="button"
            className="conta-syllabus-back"
            onClick={onBack}
          >
            <FontAwesomeIcon
              icon={faArrowLeft}
            />

            Inapoi la curs
          </button>

          <p>
            Unitatea nu a fost gasita.
          </p>

        </div>

      </div>
    );
  }


  /* =====================================================
     LECTII
  ===================================================== */

  const lessons =
    unit?.lessons || [];


  /* =====================================================
     ICON TIP LECTIE
  ===================================================== */

  const getLessonIcon = (
    type
  ) => {
    switch (type) {
      case 'practice':
        return faStar;

      case 'mission':
        return faBullseye;

      case 'project':
        return faTrophy;

      default:
        return faBookOpen;
    }
  };


  /* =====================================================
     LABEL TIP LECTIE
  ===================================================== */

  const getLessonTypeLabel = (
    type
  ) => {
    switch (type) {
      case 'practice':
        return 'Aplicatie';

      case 'mission':
        return 'Misiune';

      case 'project':
        return 'Proiect';

      default:
        return 'Lectie';
    }
  };


  /* =====================================================
     START UNITATE
  ===================================================== */

  const handleStartUnit =
    () => {

      const firstLesson =
        lessons[0];

      if (!firstLesson) {
        return;
      }

      navigate(
        '/contabilitate-primara/lesson',
        {
          state: {
            unitId:
              unit.id,

            lessonId:
              firstLesson.id,

            lessonType:
              firstLesson.type,

            unitTitle:
              unit.title,

            lessonTitle:
              firstLesson.title,
          },
        }
      );
    };


  /* =====================================================
     RENDER
  ===================================================== */

  return (
    <div className="conta-syllabus-page">

      <div className="conta-syllabus-shell">


        {/* INAPOI */}

        <button
          type="button"
          className="conta-syllabus-back"
          onClick={onBack}
        >

          <FontAwesomeIcon
            icon={faArrowLeft}
          />

          Inapoi la curs

        </button>


        {/* =================================================
            HERO
        ================================================= */}

        <section className="conta-syllabus-hero">

          <div className="conta-syllabus-hero-main">

            <span className="conta-syllabus-eyebrow">
              UNITATEA {unit.id}
            </span>


            <h1>
              {unit.title}
            </h1>


            <p>
              {unit.description}
            </p>


            <div className="conta-syllabus-actions">

              <button
                type="button"
                className="conta-syllabus-primary"
                onClick={
                  handleStartUnit
                }
              >

                Continua unitatea

                <FontAwesomeIcon
                  icon={faPlay}
                />

              </button>

            </div>

          </div>


          {/* =================================================
              SUMAR
          ================================================= */}

          <div className="conta-syllabus-summary">

            <div className="conta-syllabus-summary-row">

              <span>
                Lectii
              </span>

              <strong>
                {lessons.length}
              </strong>

            </div>


            <div className="conta-syllabus-summary-row">

              <span>
                Tip continut
              </span>

              <strong>
                Lectii si aplicatii
              </strong>

            </div>


            <div className="conta-syllabus-summary-row">

              <span>
                Nivel
              </span>

              <strong>
                Incepator
              </strong>

            </div>

          </div>

        </section>


        {/* =================================================
            PROGRAMA
        ================================================= */}

        <section className="conta-syllabus-program">

          <div className="conta-syllabus-program-heading">

            <span>
              PROGRAMA
            </span>

            <h2>
              Ce vei parcurge
            </h2>

          </div>


          <div className="conta-syllabus-card">

            <div className="conta-syllabus-card-header">

              <div>

                <span>
                  UNITATEA {unit.id}
                </span>

                <h3>
                  {unit.title}
                </h3>

              </div>

            </div>


            {/* =================================================
                LECTII
            ================================================= */}

            <div className="conta-syllabus-lessons">

              {lessons.map(
                (
                  lesson,
                  lessonIndex
                ) => (

                  <div
                    key={
                      lesson.id
                    }
                    className="conta-syllabus-lesson-row"
                  >

                    <div className="conta-syllabus-lesson-icon">

                      <FontAwesomeIcon
                        icon={
                          getLessonIcon(
                            lesson.type
                          )
                        }
                      />

                    </div>


                    <div className="conta-syllabus-lesson-type">

                      {
                        getLessonTypeLabel(
                          lesson.type
                        )
                      }

                    </div>


                    <div className="conta-syllabus-lesson-title">

                      {
                        lesson.title
                      }

                    </div>


                    <div className="conta-syllabus-lesson-number">

                      {
                        lessonIndex +
                        1
                      }

                    </div>

                  </div>

                )
              )}

            </div>


            {/* =================================================
                FOOTER
            ================================================= */}

            <div className="conta-syllabus-card-footer">

              <button
                type="button"
                className="conta-syllabus-primary"
                onClick={
                  handleStartUnit
                }
              >

                Incepe unitatea

                <FontAwesomeIcon
                  icon={faPlay}
                />

              </button>

            </div>

          </div>

        </section>

      </div>

    </div>
  );
};


export default ContaPrimaraSyllabus;